import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../shared/axiosInstance";
const CompanySignUp = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // ✅ Parse query parameters from URL
    const queryParams = new URLSearchParams(location.search);
    const prefilledEmail = queryParams.get("email") || "";
    const prefilledRole = queryParams.get("role") || "Recruiter";
    const prefilledCompanyId = queryParams.get("companyId") || "";
    const prefilledCompanyName = queryParams.get("companyName") || "";

    // ✅ State for form
    const [formData, setFormData] = useState({
        email: prefilledEmail,
        firstName: "",
        lastName: "",
        role: prefilledRole,
        company: prefilledCompanyId, // ✅ Assign company ID
        password: "",
    });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!formData.firstName.trim() || !formData.lastName.trim()) {
            setError("First and last name are required.");
            setLoading(false);
            return;
        }

        if (!formData.password.trim()) {
            setError("Password is required.");
            setLoading(false);
            return;
        }

        try {
            await api.post("/auth/register-company", formData);
            navigate("/employer-dashboard");
        } catch (err) {
            setError(err.response?.data?.message || err.response?.data?.error || "An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-darkblue text-lightgray">
            <div className="w-full max-w-md bg-bluegray shadow-lg rounded-lg p-6">
                {/* ✅ Header */}
                <h1 className="text-3xl font-bold text-center text-orange mb-6">
                    Join {prefilledCompanyName}
                </h1>

                {/* ✅ Error Message */}
                {error && <div className="bg-red text-white text-sm p-2 rounded mb-4">{error}</div>}

                {/* ✅ Form */}
                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Email */}
                    <div>
                        <label className="block text-sm font-medium text-lightblue">Email</label>
                        <input type="email" value={formData.email} readOnly className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue" />
                    </div>

                    {/* First Name */}
                    <div>
                        <label className="block text-sm font-medium text-lightblue">First Name</label>
                        <input
                            type="text"
                            name="firstName"
                            placeholder="Enter First Name"
                            onChange={handleChange}
                            required
                            className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue"
                        />
                    </div>

                    {/* Last Name */}
                    <div>
                        <label className="block text-sm font-medium text-lightblue">Last Name</label>
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Enter Last Name"
                            onChange={handleChange}
                            required
                            className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue"
                        />
                    </div>

                    {/* Company */}
                    <div>
                        <label className="block text-sm font-medium text-lightblue">Company</label>
                        <input type="text" value={prefilledCompanyName} readOnly className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue" />
                    </div>

                    {/* Password */}
                    <div>
                        <label className="block text-sm font-medium text-lightblue">Password</label>
                        <input
                            type="password"
                            name="password"
                            placeholder="Enter Password"
                            onChange={handleChange}
                            required
                            className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue"
                        />
                    </div>

                    {/* ✅ Submit Button */}
                    <button
                        type="submit"
                        className="w-full p-2 bg-orange text-darkblue font-bold rounded hover:bg-deeporange transition duration-200"
                        disabled={loading}
                    >
                        {loading ? "Processing..." : "Create Account"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CompanySignUp;
